import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const style = require('./QuotesPage.less');

export default class QuotesPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<AccessPermissionChecker name={PERMISSION_NAMES.CAN_VIEW_QUOTES} isPage>
				<div>
					<Route
						path="/buyer/quotes"
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: '/buyer/quotes/overview',
								}}
							/>
						)}
					/>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</div>
			</AccessPermissionChecker>
		);
	}
}
